import { CreatePayment, IPaymentQueueWithExternalSource } from '@getgreenline/homi-shared'
import { ReceiptModels } from '@getgreenline/receipts'

export const getUnpaidOrderReceiptDataWithoutReceiptSettings = ({
  companyName,
  locationName,
  selectedPayment,
  paymentQueue,
}: {
  companyName: string
  locationName: string | undefined
  selectedPayment: CreatePayment
  paymentQueue: IPaymentQueueWithExternalSource
}): Omit<ReceiptModels.IUnpaidOrderReceiptData, 'receiptSettings'> | undefined => {
  if (!companyName || !locationName) return

  const payment = selectedPayment.getNetworkTransferObject()
  if (!payment) return

  const { createDate } = paymentQueue
  if (!createDate) return

  const customerName = paymentQueue.customerName || null

  const subTotal = selectedPayment.subTotal

  const paymentQueueData: ReceiptModels.IPaymentQueueData = {
    createDate,
    customerName,
    subTotal,
  }

  return { companyName, locationName, payment, paymentQueueData }
}
